import { ProtectiveTube } from "@domain/project/floorplan/wiring/protective-tube";
import { ProtectiveTubeRow } from "@pdf/export-services/product-information-pages/floorplan-information-pages/protective-tubes/protective-tube-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { Headlines, ImagePaths, TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";
import { FloorplanInformationTable } from "../floorplan-information-table";

export class ProtectiveTubesRowHeaders {
  public readonly NUMBER = $localize`:@@pdfExport.protectiveTubesTable.header.number:Nr.`;
  public readonly DISPLAY_NAME = $localize`:@@pdfExport.protectiveTubesTable.header.displayName:Anzeigename`;
  public readonly NAME = $localize`:@@pdfExport.protectiveTubesTable.header.name:Name`;
  public readonly MATERIAL = $localize`:@@pdfExport.protectiveTubesTable.header.material:Material`;
  public readonly NOTES = $localize`:@@pdfExport.protectiveTubesTable.header.notes:Notizen`;
}

export class ProtectiveTubesTable extends FloorplanInformationTable {
  readonly headlines = new Headlines();
  readonly rowHeaders = new ProtectiveTubesRowHeaders();
  override readonly headline = this.headlines.PROTECTIVE_TUBES;
  override readonly columns: TableColumn[];
  override readonly rows: ProtectiveTubeRow[];

  constructor(pdf: jsPDF, protectiveTubes: ProtectiveTube[]) {
    super(ImagePaths.PROTECTIVE_TUBE);
    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.DISPLAY_NAME, 180, 156),
      new TableColumn(this.rowHeaders.NAME, 360, 136),
      new TableColumn(this.rowHeaders.MATERIAL, 520, 146),
      new TableColumn(this.rowHeaders.NOTES, 690, 750),
    ];

    this.rows = protectiveTubes.map(
      (protectiveTube) =>
        new ProtectiveTubeRow(
          pdf,
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(protectiveTube.positionId),
            this.rowHeaders.NUMBER,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(protectiveTube.displayName),
            this.rowHeaders.DISPLAY_NAME,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(protectiveTube.name),
            this.rowHeaders.NAME,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(protectiveTube.material),
            this.rowHeaders.MATERIAL,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(protectiveTube.notes),
            this.rowHeaders.NOTES,
          ),
        ),
    );
    this.height = this.calculateHeight(this.rows);
  }
}
